export enum UserTypeEnum {
	CustomerSupport = 7,
	ContentManager = 8
}
